import React, { useState } from "react";
import { signInWithEmailAndPassword, updatePassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [name, setName] = useState("");
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (!userDoc.exists()) {
        // 初回ログイン → 新しいパスワード＆名前入力へ
        setIsFirstLogin(true);
      } else {
        // 登録済み → ダッシュボードへ
        navigate("/admin/groups");
      }
    } catch (err) {
      setError("ログインに失敗しました");
    }
  };

  const handleFirstSetup = async (e: React.FormEvent) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user) return;

    try {
      // パスワード変更
      await updatePassword(user, newPassword);

      // Firestoreに情報保存
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        name,
        role: "user",
      });

      navigate("/admin/groups");
    } catch (err) {
      setError("設定に失敗しました");
    }
  };

  return (
    <div className="main-admin">
      <div className="login-form">
        <div>
          <h1>JBC管理画面</h1>

          {!isFirstLogin ? (
            <form onSubmit={handleLogin} className="form">
              <input
                type="email"
                placeholder="メールアドレス"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                placeholder="パスワード"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button type="submit">ログイン</button>
            </form>
          ) : (
            <form onSubmit={handleFirstSetup} className="form">
              <input
                type="text"
                placeholder="名前（表示名）を入力してください"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="password"
                placeholder="新しいパスワードを入力してください"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button type="submit">登録してログイン</button>
            </form>
          )}

          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default Login;
